import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.js';
import LoadingSpinner from './common/LoadingSpinner.js';

/**
 * Admin Route component that restricts access to admin users only
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The components to render if authorized
 * @returns {JSX.Element} - React component
 */
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Show loading state while checking auth
  if (loading) {
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to dashboard if not admin
  if (user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  // Render children if user is admin
  return <>{children}</>;
};

export default AdminRoute;

